module.exports = __webpack_public_path__ + "img/home-nv.2ace3dd9.png";